/**
 * License Challenge.
 *
 * @group DRM
 *
 * @beta
 */
export const CHALLENGE = 'Challenge';
//# sourceMappingURL=CHALLENGE.js.map